// © Microsoft Corporation. All rights reserved.

const DefaultSize1ColumnWidth = 300;
const DefaultSize2ColumnWidth = 624;
const DefaultSize3ColumnWidth = 948;
const DefaultSize4ColumnWidth = 1272;
const DefaultSize5ColumnWidth = 1596;
const DefaultGutterSize = 24;

export const Size1ColumnWidth = DefaultSize1ColumnWidth;
export let Size2ColumnWidth = DefaultSize2ColumnWidth;
export let Size3ColumnWidth = DefaultSize3ColumnWidth;
export let Size4ColumnWidth = DefaultSize4ColumnWidth;
export let Size5ColumnWidth = DefaultSize5ColumnWidth;
export let GutterSize = DefaultGutterSize;
export type ColumnsWidths = {
    Size1ColumnWidth: number;
    Size2ColumnWidth: number;
    Size3ColumnWidth: number;
    Size4ColumnWidth: number;
    Size5ColumnWidth: number;
};

/** Updates the current ColumnWidths based on changes in gutterSize */
export function updateColumnWidths(gutterSize: number): void {
    GutterSize = gutterSize;
    const newSizes = getUpdatedColumnWidths(gutterSize);
    Size5ColumnWidth = newSizes.Size5ColumnWidth;
    Size4ColumnWidth = newSizes.Size4ColumnWidth;
    Size3ColumnWidth = newSizes.Size3ColumnWidth;
    Size2ColumnWidth = newSizes.Size2ColumnWidth;
}

/** Get updated  ColumnWidths based on a given gutter size but don't update the global values */
export function getUpdatedColumnWidths(gutterSize: number): ColumnsWidths {
    return {
        Size1ColumnWidth,
        Size2ColumnWidth: (Size1ColumnWidth * 2) + gutterSize,
        Size3ColumnWidth: (Size1ColumnWidth * 3) + (gutterSize * 2),
        Size4ColumnWidth: (Size1ColumnWidth * 4) + (gutterSize * 3),
        Size5ColumnWidth: (Size1ColumnWidth * 5) + (gutterSize * 4)
    };
}

/** Resets the ColumnWidths to their default values */
export function resetColumnWidthsAndGutterSize(): void {
    GutterSize = DefaultGutterSize;
    Size2ColumnWidth = DefaultSize2ColumnWidth;
    Size3ColumnWidth = DefaultSize3ColumnWidth;
    Size4ColumnWidth = DefaultSize4ColumnWidth;
    Size5ColumnWidth = DefaultSize5ColumnWidth;
}